import type { RbacPermissionsEntity } from './rbac-permissions.model';
import type { RbacPermissionsState } from './rbac-permissions.reducer';
import { RBAC_PERMISSIONS_FEATURE_KEY } from './rbac-permissions.reducer';

import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectRbacPermissionsState = createFeatureSelector<RbacPermissionsState>(RBAC_PERMISSIONS_FEATURE_KEY);

export const selectPermissions = createSelector(
    selectRbacPermissionsState,
    (state: RbacPermissionsState): RbacPermissionsEntity => state?.permissions
);
